export default [{
    id: "38001",
    name: "AOU Careggi",
},{
    id: "38002",
    name: "Universita'Cattolica Del Sacro Cuore - UNICATT",
},{
    id: "38003",
    name: "Ospedale Fatebenefratelli e Oftalmico, ASST Fatebenefratelli Sacco",
},{
    id: "38004",
    name: "AOU di Padova",
},{
    id: "38005",
    name: "Istituto Nazionale dei Tumori, Fondazione IRCCS",
}, ];